<script>
import ButtonRedirect from "@/components/helpers/ButtonRedirect.vue";

export default {
  components: {
    ButtonRedirect,
  },

  methods: {
    redirectToChat() {
      window.open("https://t.me/+SchCT24ZG0OG-dKZ");
    },
  },
};
</script>

<template>
  <div class="telegram-chat-vip">
    <div class="telegram-chat-vip__wrapper">
      <h4 class="telegram-chat-vip__title">Только для Франшиза</h4>
      <p class="telegram-chat-vip__text">
        Присоединяйся к нашему Telegram-каналу для партнеров Франшиза и Франшиза
        Голд
      </p>

      <button-redirect
        class="telegram-chat-vip__link"
        :arrow-position="'right'"
        :text="'Открыть в Telegram'"
        :button-style="'bold'"
        @click="redirectToChat"
      />
    </div>

    <div class="telegram-chat-vip__img">
      <img src="../assets/images/telegram_chat_vip.png" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.telegram-chat-vip {
  background: $gold-main;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 16px;

  &__wrapper {
    padding: 16px 0 16px 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__img {
    display: flex;
    align-items: center;

    > img {
      width: 120px;
    }
  }

  &__title {
    @include body-1-bold;
    color: $dark-primary;
    margin-bottom: 4px;
  }

  &__text {
    @include caption-1;
    color: $dark-primary;
    margin-bottom: 16px;
  }

  &__link {
    margin-top: auto;
  }
}

@media (max-width: 576px) {
  .telegram-chat-vip {
    &__img {
      max-width: 71px;
      min-width: 71px;

      img {
        width: 100%;
      }
    }
  }
}
</style>
